$shm_opencode_app $shm_agent_app
	Provider_label $mol_labeler
		title \Провайдер
		Content <= Provider $mol_select
			value? <=> agent_provider_id? \
			options <= agent_provider_options /
			dictionary <= agent_provider_dict *
	Custom_provider $mol_expander
		title \Добавить провайдера
		expanded? <=> custom_provider_expanded? false
		content /
			<= Custom_provider_content $mol_list
				rows /
					<= Custom_provider_id_label $mol_labeler
						title \Provider ID
						Content <= Custom_provider_id $mol_string
							hint \custom
							value? <=> custom_provider_id? \
					<= Custom_provider_name_label $mol_labeler
						title \Название провайдера
						Content <= Custom_provider_name $mol_string
							value? <=> custom_provider_name? \
					<= Custom_provider_base_url_label $mol_labeler
						title \Base URL
						Content <= Custom_provider_base_url $mol_string
							hint \http://127.0.0.1:1234/v1
							value? <=> custom_provider_base_url? \
					<= Custom_provider_api_key_label $mol_labeler
						title \API key
						Content <= Custom_provider_api_key $mol_password
							value? <=> custom_provider_api_key? \
					<= Custom_provider_model_id_label $mol_labeler
						title \Model ID
						Content <= Custom_provider_model_id $mol_string
							hint \model
							value? <=> custom_provider_model_id? \
					<= Custom_provider_model_name_label $mol_labeler
						title \Название модели
						Content <= Custom_provider_model_name $mol_string
							value? <=> custom_provider_model_name? \
					<= Custom_provider_add $mol_button_major
						title \Добавить провайдера
						click? <=> custom_provider_add? null
